import { render, staticRenderFns } from "./TaskSidePanel.vue?vue&type=template&id=3425b50c&scoped=true"
import script from "./TaskSidePanel.vue?vue&type=script&lang=js"
export * from "./TaskSidePanel.vue?vue&type=script&lang=js"
import style0 from "./TaskSidePanel.vue?vue&type=style&index=0&id=3425b50c&prod&lang=scss&scoped=true"
import style1 from "./TaskSidePanel.vue?vue&type=style&index=1&id=3425b50c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3425b50c",
  null
  
)

export default component.exports